export const getRegistrationHasBeenSent = state => state.registration.sent;
export const getRegistrationSending = state => state.registration.sending;
export const getRegistrationHasFailed = state => state.registration.failed;
export const getRegistrationErrorMessage = state => state.registration.errorMessage;
